<template>
    <div>
        <b-form>
            <div class="row">
                <div class="col-12">
                    <card-title-component :title="$t('addGuardian.title')"></card-title-component>
                    <div class="card-content">
                        <div class="row">
                            <div class="col">
                                <b-form-group id="email-form-group"
                                              class="o-label"
                                              :label="$t('addGuardian.email')"
                                              label-for="email-input">
                                    <b-form-input id="email-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localEmail"
                                                  required
                                                  :placeholder="$t('addGuardian.emailPlaceholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <b-form-group id="firstname-form-group"
                                              class="o-label"
                                              :label="$t('addGuardian.firstname')"
                                              label-for="firstname-input">
                                    <b-form-input id="firstname-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localFirstname"
                                                  required
                                                  :placeholder="$t('addGuardian.firstnamePlaceholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col">
                                <b-form-group id="name-form-group"
                                              class="o-label"
                                              :label="$t('addGuardian.lastname')"
                                              label-for="name-input">
                                    <b-form-input id="name-input"
                                                  class="o-form"
                                                  type="text"
                                                  v-model="localName"
                                                  required
                                                  :placeholder="$t('addGuardian.lastnamePlaceholder')">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 button-div">
                    <b-button class="o-button" v-on:click="cancel">
                        {{$t('addGuardian.cancelButton')}}
                    </b-button>
                    <b-button class="o-button" v-on:click="invite">
                        {{$t('addGuardian.inviteButton')}}
                    </b-button>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import i18n from '../../assets/i18n/lang'
    import {mapActions} from 'vuex'
    import {
        INVITATIONS_NAMESPACE,
        INVITATIONS_ACTION_INVITE
    } from '../../store/modules/invitations-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'

    export default {
        name: 'AddGuardian',
        components: { 'card-title-component': CardTitleComponent },
        data () {
            return {
                localEmail: '',
                localFirstname: '',
                localName: '',
                modal_state: 'invited'
            }
        },
        methods: {
            ...mapActions(INVITATIONS_NAMESPACE, [
                INVITATIONS_ACTION_INVITE
            ]),
            invite () {
                this.inviteInvitation({
                    email: this.localEmail,
                    firstname: this.localFirstname,
                    name: this.localName,
                    locale: i18n.locale
                })
                this.localEmail = ''
                this.localFirstname = ''
                this.localName = ''
                this.$root.$emit('bv::hide::modal', 'add-guardian-modal')
            },
            cancel () {
                this.$root.$emit('bv::hide::modal', 'add-guardian-modal')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/guardian/AddGuardianComponent.vue